<template>
    <modal name="preTestGate" :adaptive="true" width="100%" height="100%">
        <div class="content prewrap">
            <div class="preTestGate">
                <h3 class="pretitle">사전 역량 체크리스트</h3>
                <h3 class="preText">본 학습과 관련된 학습자의 <span class="pointcolor">사전 역량 수준을 진단</span>하고<br>
                수준에 따른 <span class="pointcolor">보완학습자료</span>를 제공합니다.
                </h3>
                <ul class="pre_list">
                    <li><span class="pointcolor">총 20문항(5점 척도)</span>으로 구성되어 있습니다.</li>
                    <li>사전 역량 진단 결과에 따라 <span class="pointcolor">초급, 중급, 고급 수준의 보완학습자료를 다운로드</span>할 수 있습니다.</li>
                    <li>보완학습자료를 활용하여 <span class="pointcolor">학습이해도</span>를 <span class="pointcolor">향상</span>시키길 바랍니다.</li>
                </ul>
            </div>
            <div class="answer_reset prebtwrap">
                <button class="resetbt preTest main" @click="closeModal">사전 역량 체크리스트 바로가기</button>
                <button class="resetbt preTest sub" @click="$emit('skip')">닫기</button>
            </div>
        </div>
    </modal>
</template>
<script>
export default {
    data(){
        return{
            list : []
        }
    },
    methods:{
        closeModal(){
            this.$modal.hide('preTestGate');
        },
    },
    mounted(){
    }
}
</script>